import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const authService = {
  login: async (email: string, senha: string) => {
    const loginApi = axios.create({
      baseURL: API_URL,
      headers: { 'Content-Type': 'application/json' },
    });
    const response = await loginApi.post('/usuarios/login', { email, senha });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.usuario));
    }
    return response.data;
  },
  refresh: async () => {
    const refreshApi = axios.create({
      baseURL: API_URL,
      headers: { 'Content-Type': 'application/json' },
    });
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token available for refresh');
    }
    const response = await refreshApi.post('/usuarios/refresh', {}, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.usuario));
    }
    return response.data;
  },
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
  register: async (data: { nome: string; email: string; senha: string; empresaId: string }) => {
    const registerApi = axios.create({
      baseURL: API_URL,
      headers: { 'Content-Type': 'application/json' },
    });
    const response = await registerApi.post('/usuarios/create', {
      ...data,
      role: 'Admin',
    });
    return response.data;
  },
  exportMyData: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/usuarios/meus-dados`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
    return response.data;
  },
  deleteMyAccount: async (confirmacao: string) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${API_URL}/usuarios/minha-conta`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { confirmacao },
    });
    return response.data;
  },
};
